<div class="article-detail">
    <div class="banner-article" 
        [ngStyle]="{'background-image' : 'url('+ apiAsset + dataArticle?.current.picture +')'}" 
        [ngClass]="(dataArticle?.current.picture)?'theres-img': colorBg">
        <div class="container position-relative">
            <div class="date d-md-block d-none">
                <p *ngIf="slugArticle != 'events'">{{ dataArticle?.current.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                <p *ngIf="dataArticle?.current.media">Media: {{ dataArticle?.current.media }}</p>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-7 ver-1" *ngIf="slugArticle != 'events'">
                    <a routerLink="/news-and-events" class="back d-inline-flex align-items-center">
                        <img class="icon-back" src="../../../../assets/images/icon/arrow-big-right.png" alt="">
                        <span class="pl-2">{{ isLang?.back }}</span>
                    </a>
                    <div class="title">
                        <p>{{ dataArticle?.current.subtitle }}</p>
                        <h3 class="mb-0">{{ dataArticle?.current.title }}</h3>
                    </div>
                </div>
                <div class="col-lg-7 col-md-8 ver-2" *ngIf="slugArticle == 'events'">
                    <a routerLink="/news-and-events" class="back d-inline-flex align-items-center">
                        <img class="icon-back" src="../../../../assets/images/icon/arrow-big-right.png" alt="">
                        <span class="pl-2">{{ isLang?.back }}</span>
                    </a>
                    <div class="warp d-flex">
                        <div class="w-date text-center pr-2">
                            <h2 class="day mb-0">{{ dataArticle?.current.published_at | date:'dd' }}</h2>
                            <span class="month d-xl-block d-none">{{ dataArticle?.current.published_at | date:'MMMM yyyy' }}</span> 
                            <span class="month d-xl-none d-block">{{ dataArticle?.current.published_at | date:'MMM yyyy' }}</span>      
                        </div>
                        <div class="title pl-3">
                            <p class="mb-1">{{ dataArticle?.current.subtitle }}</p>
                            <h3 class="mb-0">{{ dataArticle?.current.title }}</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-2 media d-md-none d-block">
                    <div class="d-flex justify-content-between">
                        <p class="pr-2" *ngIf="slugArticle != 'events'">{{ dataArticle?.current.published_at | date:'EEE dd/MM/yyyy' }}</p>
                         <p *ngIf="dataArticle?.current.media">Media: {{ dataArticle?.current.media }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="warp-detail">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="desc text-justify my-4" style="min-height: 300px;" [innerHTML]="dataArticle?.current.content"></div>
                    <div class="row" *ngIf="dataArticle?.current.file">
                        <div class="col-lg-3 col-md-4 col-9 mx-md-0 mx-auto download-pdf">
                            <a href="{{apiAsset}}/{{dataArticle?.current.file}}"
                                target="_blank"
                                class="btn w-100 red-btn-icon">
                                {{ isLang?.download }} PDF 
                                <img src="../../../../assets/images/icon/dwnload-icon.svg" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="artic-gallery my-4" *ngIf="_albums.length != 0">
                        <h6 class="mini-title mb-3">{{ isLang?.gallery }}</h6>
                        <div class="row w-photo px-lg-0 px-2">
                            <div class="col-md-3 col-7 px-lg-3 px-2" *ngFor="let gal of _albums | slice:0:4; let i=index">
                                <div class="pointer" (click)="open(i)">
                                    <img class="gal-pict w-100" [src]="gal.src" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="warp-tags" *ngIf="dataTags.length != 0 ">
                        <h6 class="mini-title mb-2">Tags</h6>
                        <span class="tag pr-2" *ngFor="let tag of dataTags">#{{ tag }}</span>
                    </div>
                    <div class="other-article lane-top mt-4 py-4">
                         <div class="row px-xl-0 px-2">
                             <!-- prev article -->
                             <div class="col-6 px-xl-3 px-md-2 px-1">
                                <a routerLink="/news-and-events/{{slugArticle}}/{{dataArticle?.prev.seotitle}}" 
                                    class="other p-md-4 p-2" 
                                    *ngIf="dataArticle?.prev">
                                    <div class="row h-100 align-items-center">
                                        <div class="col-2 px-md-3 pr-0 pl-3">
                                            <img class="icon-arr" src="../../../../assets/images/icon/arrow-round-left.svg" alt="">
                                        </div>
                                        <div class="col-10 h-100">
                                            <div class="row h-100">
                                                <div class="col-12 text-right d-xl-none d-block">
                                                    <p class="other-date mb-2">{{ dataArticle?.prev.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                                                </div>
                                                <div class="col-xl-8">
                                                    <div class="title">
                                                        <p>{{ dataArticle?.prev.subtitle }}</p>
                                                        <h5 class="mb-0">{{ globalService.trimString2(dataArticle?.prev.title, 60) }}</h5>
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 pl-xl-0 d-xl-block d-none">
                                                    <p class="other-date">{{ dataArticle?.prev.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                             </div>
                             <!-- next article -->
                             <div class="col-6 px-xl-3 px-md-2 px-1">
                                <a routerLink="/news-and-events/{{slugArticle}}/{{dataArticle?.next.seotitle}}"
                                   class="other p-md-4 p-2" 
                                   *ngIf="dataArticle?.next">
                                    <div class="row h-100 align-items-center">
                                        <div class="col-10 h-100">
                                            <div class="row h-100">
                                                <div class="col-12 d-xl-none d-block">
                                                    <p class="other-date mb-2">{{ dataArticle?.next.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                                                </div>
                                                <div class="col-xl-8">
                                                    <div class="title">
                                                        <p>{{ dataArticle?.next.subtitle }}</p>
                                                        <h5 class="mb-0">{{ globalService.trimString2(dataArticle?.next.title, 60) }}</h5>
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 text-right pl-xl-0 d-xl-block d-none">
                                                    <p class="other-date">{{ dataArticle?.next.published_at | date:'EEEE dd/MM/yyyy' }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2 px-md-3 pl-0 pr-3 text-right">
                                            <img class="icon-arr" src="../../../../assets/images/icon/arrow-round-right.svg" alt="">
                                        </div>
                                    </div>
                                </a>
                             </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
